import Vue from "vue";
// import store from "@/store"
import draggable from "vuedraggable";
import Properties from "@/components/form_elements_expression/properties/Properties.vue";

import FormTitle from "@/components/form_elements_expression/forms/FormTitle";
import FormExample from "@/components/form_elements_expression/forms/FormExample";
import FormExplain from "@/components/form_elements_expression/forms/FormExplain";

import vm from "@/main";

export const FormBuilder = new Vue({
  components: {
    draggable,
    Properties,
    FormTitle,
    FormExample,
    FormExplain,
  },
  data() {
    return {
      fields: [
        {
          fieldType: "FormTitle",
          type: "Form",
          text: "タイトル・説明",
          key: "FormTitle",
          id: "",
          data: [],
          cols: 12,
        },
        {
          fieldType: "FormExample",
          type: "Form",
          text: "例文",
          key: "FormExample",
          id: "",
          data: [],
          cols: 12,
        },
        // {
        //   fieldType: "FormExplain",
        //   type: "Form",
        //   text: "Form-Explain",
        //   key: "FormExplain",
        //   id: "",
        //   data: [],
        //   cols: 12,
        // },
      ],
    };
  },
  methods: {
    deleteElement(index, form) {
      this.$delete(form, index);
      vm.$store.tabExpression = "forms";
      vm.$store.activeFieldExpression = {};
    },

    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },
    editElementProperties(field) {
      vm.$store.activeFieldExpression = field;
    },
  },
});
